import { Route } from "react-router-dom";
import AppSections from "../utils/AppSections";
import ProtectedRoute from "./ProtectedRoute";
import AnnexDataDetails from "../ui/annexdata/AnnexDataDetails";
import AnnexDataAddEdit from "../ui/annexdata/AnnexDataAddEdit";
import AnnexDataSection from "../ui/annexdata/AnnexData";

const AnnexDataRoutes = (
  <Route
    path={AppSections.ANNEXDATA}
    element={
      <ProtectedRoute>
        <AnnexDataSection />
      </ProtectedRoute>
    }
  >
    <Route path=":id/view" element={<AnnexDataDetails />} />
    <Route path=":id/edit" element={<AnnexDataAddEdit />} />
  </Route>
);

export default AnnexDataRoutes;
